export enum SubscriptionServiceType {
  None = 'None',
  Vision = 'Vision',
  Translation = 'Translation',
  Transcription = 'Transcription',
  Profile = 'Profile',
  GenAI = 'GenAI',
  TextExtraction = 'TextExtraction',
  Imei = 'Imei'
}

export const SubscriptionServiceTypes = [SubscriptionServiceType.None, SubscriptionServiceType.Vision, SubscriptionServiceType.Translation, SubscriptionServiceType.Transcription, SubscriptionServiceType.Profile, SubscriptionServiceType.Imei, SubscriptionServiceType.GenAI, SubscriptionServiceType.TextExtraction];

export const getServiceName = (serviceType: SubscriptionServiceType): string => {
  switch (serviceType) {
    case SubscriptionServiceType.None:
      return 'Not Selected';
    case SubscriptionServiceType.Vision:
      return 'Vision';
    case SubscriptionServiceType.Translation:
      return 'Translation';
    case SubscriptionServiceType.Transcription:
      return 'Transcription';
    case SubscriptionServiceType.Profile:
      return 'Profile';
    case SubscriptionServiceType.GenAI:
      return 'GenAI';
    case SubscriptionServiceType.TextExtraction:
      return 'TextExtraction';
    case SubscriptionServiceType.Imei:
      return 'Imei';
    default:
      throw new Error(`Service type ${serviceType} does not exist.`);
  }
};
